// Old contexts and invalid values must never opt a hotel out of card guarantee.
export function normalizeBookingCardPolicy(value) {
  return value === "not_required" ? "not_required" : "required";
}
